import React, { useState } from "react";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { ref, set, get } from "firebase/database";
import { auth, db } from "../firebase";
import "./Auth.css";
import logo from "./logo.png";
import { getStorage, ref as sRef, uploadBytes, getDownloadURL } from "firebase/storage";
// Import your country list
import { countryList } from "../utils/countries";
import { useTranslation } from "react-i18next";

const Login = () => {
  const [mode, setMode] = useState("select");
  const [role, setRole] = useState("passenger");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  
  const [country, setCountry] = useState("Papua New Guinea"); // Default
const [serviceTypes, setServiceTypes] = useState([]);  
  const [photo, setPhoto] = useState(null);
const [photoPreview, setPhotoPreview] = useState("");

  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ msg: "", type: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState("");
  const { t, i18n } = useTranslation();

const services = [
  { id: "taxi", name: t("service_taxi") },
  { id: "bus", name: t("service_bus") },
  { id: "rental", name: t("service_rental") },
  { id: "boat", name: t("service_boat") },
  { id: "delivery", name: t("service_delivery") },
  { id: "motorbike", name: t("service_motorbike") },
];

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast({ msg: "", type: "" }), 3500);
  };

const checkPasswordStrength = (pwd) => {
  if (pwd.length < 6) return t("weak");

  if (pwd.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/)) {
    return t("strong");
  }

  return t("medium");
};
  // 🔹 NEW: Geocode Function
  const geocodeCity = async (city, country) => {
  const query = encodeURIComponent(`${city}, ${country}`);


    try {
      const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${query}`);
      const results = await response.json();
      if (results && results.length > 0) {
        return [parseFloat(results[0].lat), parseFloat(results[0].lon)];
      }
    } catch (error) { console.log("Geocode error:", error); }
    return null;
  };

  // signup......///
  const handleSignup = async () => {
  // Check for all fields + Password Match
if (!email || !password || !confirmPassword || !name || !phone || !city) {

  showToast("❌ Please fill all required fields", "error");
  return;
}

if (password !== confirmPassword) {
  showToast("❌ Passwords do not match!", "error");
  return;
}

if (
  role === "driver" &&
  serviceTypes.length === 0
) {  
  showToast("❌ Please select a service type", "error");
  return;
}

if (!photo) {
  showToast("❌ Please upload a profile photo", "error");
  return;
}
  
  // ... rest of your code ...
    setLoading(true);

    // 🔹 NEW: Get Coordinates
const coords = await geocodeCity(city, country);    
    if (!coords) {
      showToast("❌ Could not find location on map.", "error");
      setLoading(false);
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const uid = userCredential.user.uid;

      const storage = getStorage();
      const photoRef = sRef(storage, `${role}s/${uid}/profile.jpg`);
      await uploadBytes(photoRef, photo);
      const photoURL = await getDownloadURL(photoRef);

      const userData = {
uid, name, email, phone, city, country, photoURL,        
        createdAt: Date.now(),
        position: coords, // 👈 Saved coords
      };


      if (role === "driver") {
userData.serviceTypes = serviceTypes;        
        userData.online = false;
        await set(ref(db, `drivers/${uid}`), userData);
      } else {
        await set(ref(db, `passengers/${uid}`), userData);
      }

      showToast("🎉 Signup successful! Redirecting...", "success");
      setTimeout(() => setMode("login"), 1500);
    } catch (err) {

  let errorMessage =
    t("signup_failed");

  if (
    err.code ===
    "auth/email-already-in-use"
  ) {

    errorMessage =
      t("email_already_exists");

  } else if (
    err.code ===
    "auth/invalid-email"
  ) {

    errorMessage =
      t("invalid_email");

  } else if (
    err.code ===
    "auth/weak-password"
  ) {

    errorMessage =
      t("weak_password_error");

  } else if (
    err.code ===
    "auth/network-request-failed"
  ) {

    errorMessage =
      t("network_error");
  }

  showToast(
    `⚠️ ${errorMessage}`,
    "error"
  );
}



    setLoading(false);
  };

  //.......login...///
const handleLogin = async () => {
  setLoading(true);

  // 1. Declare these at the top level of the function
  let finalData = null;
  let finalRole = "";

  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email.toLowerCase(),
      password
    );
    const uid = userCredential.user.uid;

    // 2. Check Passengers first
    const pSnap = await get(ref(db, `passengers/${uid}`));
    if (pSnap.exists()) {
      finalData = pSnap.val();
      finalRole = "passenger";
    } 
    // 3. If not found, check Drivers
    else {
      const dSnap = await get(ref(db, `drivers/${uid}`));
      if (dSnap.exists()) {
        finalData = dSnap.val();
        finalRole = "driver";
      }
    }

    // 4. Verification Check
    if (!finalData) {
      showToast("❌ Account not found in KinaTrip database", "error");
      setLoading(false);
      return;
    }

    // 5. Save to Storage (Using the verified 'finalRole')
    localStorage.setItem("role", finalRole);
    localStorage.setItem("uid", uid);
    localStorage.setItem("name", finalData.name);
    localStorage.setItem("country", finalData.country || "Papua New Guinea"); 
    
    if (finalRole === "passenger") {
      localStorage.setItem("passengerName", finalData.name);
    } else {
      localStorage.setItem("driverName", finalData.name);
    }

    showToast(`✅ Welcome back, ${finalData.name}!`, "success");

    // 6. The Redirect (Using window.location.href for stability)
    setTimeout(() => {
      window.location.href = finalRole === "passenger" ? "/passenger" : "/driver";
    }, 1200);

  } catch (err) {
    showToast(`❌ Login error: ${err.message}`, "error");
  }
  setLoading(false);
};

  // --- UI Renders (Kept exactly like your original) ---
  if (mode === "select") {
    return (
      <div className="auth-page">
        <div className="auth-header">
          <img src={logo} alt="KinaTrip Logo" className="auth-logo" />
          <h2 className="auth-title">KinaTrip</h2>
          <select
  className="language-select"
  value={i18n.language}
  onChange={(e) => {
    i18n.changeLanguage(e.target.value);
    localStorage.setItem("lang", e.target.value);
  }}
>
  <option value="en">English</option>
<option value="tpi">Tok Pisin</option>
<option value="fr">French</option>
<option value="es">Spanish</option>
<option value="pt">Portuguese</option>
<option value="zh">Chinese</option>
<option value="ar">Arabic</option>
<option value="ru">Russian</option>
<option value="hi">Hindi</option>
<option value="id">Indonesian</option>
</select>
        </div>
<h1>{t("select_user_type")}</h1>        
        <div className="role-buttons">
          <button className="btn" onClick={() => { setRole("passenger"); setMode("signup"); }}>{t("passenger")}</button>
          <button className="btn" onClick={() => { setRole("driver"); setMode("signup"); }}>{t("driver_service_provider")}</button>
        </div>



        <p onClick={() => setMode("login")} className="switch-link">{t("already_have_account")}</p>
        <Toast msg={toast.msg} type={toast.type} />

      </div>
    );
  }





  return (
    <div className="auth-page">
      <div className="auth-header">
        <img src={logo} alt="KinaTrip Logo" className="auth-logo" />
        <h2 className="auth-title">KinaTrip</h2>
      </div>

   <h1>
  {mode === "login"
    ? t("login")
    : `${t("signup")} - ${
        role === "driver"
          ? t("driver_service_provider")
          : t("passenger")
      }`}
</h1>

      {mode === "login" && (
        <>
          <input type="email" placeholder={t("email")} value={email} onChange={(e) => setEmail(e.target.value.toLowerCase())} />
          <input type="password" placeholder={t("password")}value={password} onChange={(e) => setPassword(e.target.value)} />
          <button className="btn" onClick={handleLogin}>{loading ? t("please_wait") : t("login")}</button>
        </>
      )}



  {mode === "signup" && (
  <div className="form-container">
    <input
      type="text"
      placeholder={
        role === "driver"
          ? t("business_service_name")
          : t("full_name")
      }
      value={name}
      onChange={(e) => setName(e.target.value)}
    />

    <input
      type="text"
      placeholder={t("phone")}
      value={phone}
      onChange={(e) => setPhone(e.target.value)}
    />

    <input
      type="email"
      placeholder={t("email")}
      value={email}
      onChange={(e) => setEmail(e.target.value.toLowerCase())}
    />

    <select
      value={country}
      onChange={(e) => setCountry(e.target.value)}
      className="country-select"
    >
      {countryList.map((c) => (
        <option key={c} value={c}>{c}</option>
      ))}
    </select>

<div className="upload-section">

  <label>{t("upload_profile_photo")}</label>

  {photoPreview && (
    <img
      src={photoPreview}
      alt="preview"
      className="preview-img"
    />
  )}

  <label className="custom-file-btn">
    📷 {photo ? photo.name : t("choose_file")}

    <input
      type="file"
      accept="image/*"
      hidden

      onChange={(e) => {

        const file = e.target.files[0];

        if (file) {

          setPhoto(file);

          setPhotoPreview(
            URL.createObjectURL(file)
          );
        }
      }}
    />
  </label>

</div>

    <div className="password-field">
      <input
        type={showPassword ? "text" : "password"}
        placeholder={t("password")}
        value={password}
        onChange={(e) => {
          setPassword(e.target.value);
          setPasswordStrength(checkPasswordStrength(e.target.value));
        }}
      />
      <span className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
        {showPassword ? "🙈" : "👁️"}
      </span>
    </div>

    <div className="password-field">
      <input
        type={showPassword ? "text" : "password"}
        placeholder={t("confirm_password")}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
    </div>

    <div
  className={`strength ${
    passwordStrength === t("weak")
      ? "weak"
      : passwordStrength === t("strong")
      ? "strong"
      : "medium"
  }`}
>
  {t("strength")}: {passwordStrength}
</div>

    {confirmPassword && (
      <div className={password === confirmPassword ? "match success" : "match error"}>
        {password === confirmPassword ? t("passwords_match") : t("passwords_not_match")}
      </div>
    )}





   {role === "driver" && (
  <div className="multi-service-box">

    <label
      style={{
        fontWeight: "bold",
        marginBottom: "8px",
        display: "block"
      }}
    >
      Select up to 4 services
    </label>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "10px"
      }}
    >
      {services.map((service) => {

        const selected =
          serviceTypes.includes(service.id);

        return (

          <button
            key={service.id}
            type="button"

            onClick={() => {

              if (selected) {

                setServiceTypes(
                  serviceTypes.filter(
                    (s) => s !== service.id
                  )
                );

              } else {

                if (
                  serviceTypes.length >= 4
                ) {

                  alert(
                    "Maximum 4 services allowed"
                  );

                  return;
                }

                setServiceTypes([
                  ...serviceTypes,
                  service.id
                ]);
              }
            }}

            style={{
              padding: "12px",
              borderRadius: "10px",
              border: selected
                ? "2px solid #0a84ff"
                : "1px solid #ccc",

              background: selected
                ? "#eaf4ff"
                : "#fff",

              fontWeight: "bold",
              cursor: "pointer"
            }}
          >
            {selected ? "✅ " : ""}
            {service.name}
          </button>
        );
      })}
    </div>

    <div
      style={{
        marginTop: "10px",
        fontSize: "13px",
        color: "#666"
      }}
    >
      Selected:
      {" "}
      {serviceTypes.length}/4
    </div>

  </div>
)}





    <input
      type="text"
      placeholder={t("city")}
      value={city}
      onChange={(e) => setCity(e.target.value)}
    />

   

    <button className="btn" onClick={handleSignup}>
      {loading ? t("please_wait") : t("signup")}
    </button>
  </div>
)}

  <div className="auth-bottom-links">

  <p
    className="switch-link"
    onClick={() => setMode(mode === "login" ? "signup" : "login")}
  >
    {mode === "login"
      ? t("dont_have_account")
      : t("already_have_account")}
  </p>

  <p
    className="back-link"
    onClick={() => setMode("select")}
  >
    ← {t("back")}
  </p>

</div>

<Toast msg={toast.msg} type={toast.type} />

</div>
);
};

const Toast = ({ msg, type }) => {
  if (!msg) return null;
  return <div className={`toast ${type}`}>{msg}</div>;
};

export default Login;

